import { render, staticRenderFns } from "./AboutCollectionOrder.vue?vue&type=template&id=34cee11c&scoped=true&"
import script from "./AboutCollectionOrder.vue?vue&type=script&lang=js&"
export * from "./AboutCollectionOrder.vue?vue&type=script&lang=js&"
import style0 from "./AboutCollectionOrder.vue?vue&type=style&index=0&id=34cee11c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cee11c",
  null
  
)

export default component.exports